import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  exitRowData: {},
  exitRowPassengerData: {},
  isLoading: false,
  error: "",
  hasData: false,
  exitRowDataStatus: {
    status: false,
    message: ""
  }
};
const fetchExitRowSlice = createSlice({
  name: "exitRow",
  initialState,
  reducers: {
    getExitRowRequest: state => {
      state.isLoading = true;
    },
    getExitRowSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.error = "";
      state.exitRowData = action?.payload;
      state.exitRowDataStatus.status = true;
    },
    getExitRowFailure: (state, action) => {
      state.isLoading = false;
      state.hasData = false;
      state.error = action?.payload?.response?.data;
      state.exitRowData = {};
      state.exitRowDataStatus.status = false;
    },
    setExitRowPassengerData: (state, action) => {
      state.exitRowPassengerData = action.payload;
    }
  }
});
export const {
  getExitRowRequest,
  getExitRowSuccess,
  getExitRowFailure,
  setExitRowPassengerData
} = fetchExitRowSlice.actions;
export default fetchExitRowSlice.reducer;